const width = 350;
const height = 350;
const  colors = ['#BAA6CA', '#B7DCFA', '#FFE69A', '#788195'];
const datas =  [
  {name: 'Page A', uv: 4000, pv: 2400, amt: 2400},
  {name: 'Page B', uv: 3000, pv: 1398, amt: 2210},
  {name: 'Page C', uv: 2000, pv: 9800, amt: 2290},
  {name: 'Page D', uv: 2780, pv: 3908, amt: 2000},
  {name: 'Page E', uv: 1890, pv: 4800, amt: 2181},
  {name: 'Page F', uv: 2390, pv: 3800, amt: 2500},
  {name: 'Page G', uv: 3490, pv: 4300, amt: 2100},
];
const SimpleLineCharts = {
  componentName: 'SimpleLineCharts',
  key: 'SimpleLineCharts',
  title: 'Simple Line Charts',
  width,
  height,
  colors,
  datas,
};
const CustomizedDotLineChart = {
  componentName: 'CustomizedDotLineChart',
  key: 'CustomizedDotLineChart',
  title: 'Customized Dot Line Chart',
  width,
  height,
  colors,
  datas: [
    {...datas[0], fillColor: '#48A6F2', svg: 'M512 1009.984c-274.912 0-497.76-222.848-497.76-497.76s222.848-497.76 497.76-497.76c274.912 0 497.76 222.848 497.76 497.76s-222.848 497.76-497.76 497.76zM340.768 295.936c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM686.176 296.704c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM772.928 555.392c-18.752-8.864-40.928-0.576-49.632 18.528-40.224 88.576-120.256 143.552-208.832 143.552-85.952 0-164.864-52.64-205.952-137.376-9.184-18.912-31.648-26.592-50.08-17.28-18.464 9.408-21.216 21.472-15.936 32.64 52.8 111.424 155.232 186.784 269.76 186.784 117.984 0 217.12-70.944 269.76-186.784 8.672-19.136 9.568-31.2-9.12-40.096z'},
    {...datas[1], fillColor: '#ff6384', svg: 'M517.12 53.248q95.232 0 179.2 36.352t145.92 98.304 98.304 145.92 36.352 179.2-36.352 179.2-98.304 145.92-145.92 98.304-179.2 36.352-179.2-36.352-145.92-98.304-98.304-145.92-36.352-179.2 36.352-179.2 98.304-145.92 145.92-98.304 179.2-36.352zM663.552 261.12q-15.36 0-28.16 6.656t-23.04 18.432-15.872 27.648-5.632 33.28q0 35.84 21.504 61.44t51.2 25.6 51.2-25.6 21.504-61.44q0-17.408-5.632-33.28t-15.872-27.648-23.04-18.432-28.16-6.656zM373.76 261.12q-29.696 0-50.688 25.088t-20.992 60.928 20.992 61.44 50.688 25.6 50.176-25.6 20.48-61.44-20.48-60.928-50.176-25.088zM520.192 602.112q-51.2 0-97.28 9.728t-82.944 27.648-62.464 41.472-35.84 51.2q-1.024 1.024-1.024 2.048-1.024 3.072-1.024 8.704t2.56 11.776 7.168 11.264 12.8 6.144q25.6-27.648 62.464-50.176 31.744-19.456 79.36-35.328t114.176-15.872q67.584 0 116.736 15.872t81.92 35.328q37.888 22.528 63.488 50.176 17.408-5.12 19.968-18.944t0.512-18.944-3.072-7.168-1.024-3.072q-26.624-55.296-100.352-88.576t-176.128-33.28z'},
    {...datas[2], fillColor: '#48A6F2', svg: 'M512 1009.984c-274.912 0-497.76-222.848-497.76-497.76s222.848-497.76 497.76-497.76c274.912 0 497.76 222.848 497.76 497.76s-222.848 497.76-497.76 497.76zM340.768 295.936c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM686.176 296.704c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM772.928 555.392c-18.752-8.864-40.928-0.576-49.632 18.528-40.224 88.576-120.256 143.552-208.832 143.552-85.952 0-164.864-52.64-205.952-137.376-9.184-18.912-31.648-26.592-50.08-17.28-18.464 9.408-21.216 21.472-15.936 32.64 52.8 111.424 155.232 186.784 269.76 186.784 117.984 0 217.12-70.944 269.76-186.784 8.672-19.136 9.568-31.2-9.12-40.096z'},
    {...datas[3], fillColor: '#ff6384', svg: 'M517.12 53.248q95.232 0 179.2 36.352t145.92 98.304 98.304 145.92 36.352 179.2-36.352 179.2-98.304 145.92-145.92 98.304-179.2 36.352-179.2-36.352-145.92-98.304-98.304-145.92-36.352-179.2 36.352-179.2 98.304-145.92 145.92-98.304 179.2-36.352zM663.552 261.12q-15.36 0-28.16 6.656t-23.04 18.432-15.872 27.648-5.632 33.28q0 35.84 21.504 61.44t51.2 25.6 51.2-25.6 21.504-61.44q0-17.408-5.632-33.28t-15.872-27.648-23.04-18.432-28.16-6.656zM373.76 261.12q-29.696 0-50.688 25.088t-20.992 60.928 20.992 61.44 50.688 25.6 50.176-25.6 20.48-61.44-20.48-60.928-50.176-25.088zM520.192 602.112q-51.2 0-97.28 9.728t-82.944 27.648-62.464 41.472-35.84 51.2q-1.024 1.024-1.024 2.048-1.024 3.072-1.024 8.704t2.56 11.776 7.168 11.264 12.8 6.144q25.6-27.648 62.464-50.176 31.744-19.456 79.36-35.328t114.176-15.872q67.584 0 116.736 15.872t81.92 35.328q37.888 22.528 63.488 50.176 17.408-5.12 19.968-18.944t0.512-18.944-3.072-7.168-1.024-3.072q-26.624-55.296-100.352-88.576t-176.128-33.28z'},
    {...datas[4], fillColor: '#48A6F2', svg: 'M512 1009.984c-274.912 0-497.76-222.848-497.76-497.76s222.848-497.76 497.76-497.76c274.912 0 497.76 222.848 497.76 497.76s-222.848 497.76-497.76 497.76zM340.768 295.936c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM686.176 296.704c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM772.928 555.392c-18.752-8.864-40.928-0.576-49.632 18.528-40.224 88.576-120.256 143.552-208.832 143.552-85.952 0-164.864-52.64-205.952-137.376-9.184-18.912-31.648-26.592-50.08-17.28-18.464 9.408-21.216 21.472-15.936 32.64 52.8 111.424 155.232 186.784 269.76 186.784 117.984 0 217.12-70.944 269.76-186.784 8.672-19.136 9.568-31.2-9.12-40.096z'},
    {...datas[5], fillColor: '#ff6384', svg: 'M517.12 53.248q95.232 0 179.2 36.352t145.92 98.304 98.304 145.92 36.352 179.2-36.352 179.2-98.304 145.92-145.92 98.304-179.2 36.352-179.2-36.352-145.92-98.304-98.304-145.92-36.352-179.2 36.352-179.2 98.304-145.92 145.92-98.304 179.2-36.352zM663.552 261.12q-15.36 0-28.16 6.656t-23.04 18.432-15.872 27.648-5.632 33.28q0 35.84 21.504 61.44t51.2 25.6 51.2-25.6 21.504-61.44q0-17.408-5.632-33.28t-15.872-27.648-23.04-18.432-28.16-6.656zM373.76 261.12q-29.696 0-50.688 25.088t-20.992 60.928 20.992 61.44 50.688 25.6 50.176-25.6 20.48-61.44-20.48-60.928-50.176-25.088zM520.192 602.112q-51.2 0-97.28 9.728t-82.944 27.648-62.464 41.472-35.84 51.2q-1.024 1.024-1.024 2.048-1.024 3.072-1.024 8.704t2.56 11.776 7.168 11.264 12.8 6.144q25.6-27.648 62.464-50.176 31.744-19.456 79.36-35.328t114.176-15.872q67.584 0 116.736 15.872t81.92 35.328q37.888 22.528 63.488 50.176 17.408-5.12 19.968-18.944t0.512-18.944-3.072-7.168-1.024-3.072q-26.624-55.296-100.352-88.576t-176.128-33.28z'},
    {...datas[6], fillColor: '#48A6F2', svg: 'M512 1009.984c-274.912 0-497.76-222.848-497.76-497.76s222.848-497.76 497.76-497.76c274.912 0 497.76 222.848 497.76 497.76s-222.848 497.76-497.76 497.76zM340.768 295.936c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM686.176 296.704c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM772.928 555.392c-18.752-8.864-40.928-0.576-49.632 18.528-40.224 88.576-120.256 143.552-208.832 143.552-85.952 0-164.864-52.64-205.952-137.376-9.184-18.912-31.648-26.592-50.08-17.28-18.464 9.408-21.216 21.472-15.936 32.64 52.8 111.424 155.232 186.784 269.76 186.784 117.984 0 217.12-70.944 269.76-186.784 8.672-19.136 9.568-31.2-9.12-40.096z'},
  ],
};
const SimpleBarChart = {
  componentName: 'SimpleBarChart',
  key: 'SimpleBarChart',
  title: 'Simple Bar Chart',
  width,
  height,
  colors,
  datas,
};
const MixBarChart = {
  componentName: 'MixBarChart',
  key: 'MixBarChart',
  title: 'Mix Bar Chart',
  width,
  height,
  colors,
  datas: [
    {name: 'Page A', uv: 4000, female: 2400, male: 2400},
    {name: 'Page B', uv: 3000, female: 1398, male: 2210},
    {name: 'Page C', uv: 2000, female: 9800, male: 2290},
    {name: 'Page D', uv: 2780, female: 3908, male: 2000},
    {name: 'Page E', uv: 1890, female: 4800, male: 2181},
    {name: 'Page F', uv: 2390, female: 3800, male: 2500},
    {name: 'Page G', uv: 3490, female: 4300, male: 2100},
  ],
};
const CustomShapeBarChart = {
  componentName: 'CustomShapeBarChart',
  key: 'CustomShapeBarChart',
  title: 'Custom Shape Bar Chart',
  width,
  height,
  colors,
  datas: MixBarChart.datas,
};
const BiaxialBarChart = {
  componentName: 'BiaxialBarChart',
  key: 'BiaxialBarChart',
  title: 'Biaxial Bar Chart',
  width,
  height,
  colors,
  datas,
};
const SimpleAreaChart = {
  componentName: 'SimpleAreaChart',
  key: 'SimpleAreaChart',
  title: 'Simple Area Chart',
  width,
  height,
  colors,
  datas,
};
const StackedAreaChart = {
  componentName: 'StackedAreaChart',
  key: 'StackedAreaChart',
  title: 'Stacked Area Chart',
  width,
  height,
  colors,
  datas,
};
const LineBarAreaComposedChart = {
  componentName: 'LineBarAreaComposedChart',
  key: 'LineBarAreaComposedChart',
  title: 'Line Bar Area ComposedChart',
  width,
  height,
  colors,
  datas,
};
const CustomActiveShapePieChart = {
  componentName: 'CustomActiveShapePieChart',
  key: 'CustomActiveShapePieChart',
  title: 'Custom Active Shape Pie Chart',
  width: 600,
  height,
  colors,
  dataKey: 'value',
  datas:[
    {name: 'Group A', value: 400},
    {name: 'Group B', value: 300},
    {name: 'Group C', value: 300},
    {name: 'Group D', value: 200},
  ],
};
const SpecifiedDomainRadarChart = {
  componentName: 'SpecifiedDomainRadarChart',
  key: 'SpecifiedDomainRadarChart',
  title: 'Specified Domain Radar Chart',
  width: 600,
  height: 500,
  colors,
  angle: 30,
  domain: [0, 150],
  cx: 300,
  cy: 250,
  outerRadius: 150,
  datas:[
    { subject: 'Math', A: 120, B: 110, fullMark: 150 },
    { subject: 'Chinese', A: 98, B: 130, fullMark: 150 },
    { subject: 'English', A: 86, B: 130, fullMark: 150 },
    { subject: 'Geography', A: 99, B: 100, fullMark: 150 },
    { subject: 'Physics', A: 85, B: 90, fullMark: 150 },
    { subject: 'History', A: 65, B: 85, fullMark: 150 },
  ],
};
const SimpleRadialBarChart = {
  componentName: 'SimpleRadialBarChart',
  key: 'SimpleRadialBarChart',
  title: 'Simple Radial Bar Chart',
  width: 600,
  height: 300,
  datas:[
    { name: '18-24', uv: 31.47, pv: 2400, fill: '#8884d8' },
    { name: '25-29', uv: 26.69, pv: 4567, fill: '#83a6ed' },
    { name: '30-34', uv: 15.69, pv: 1398, fill: '#8dd1e1' },
    { name: '35-39', uv: 8.22, pv: 9800, fill: '#82ca9d' },
    { name: '40-49', uv: 8.63, pv: 3908, fill: '#a4de6c' },
    { name: '50+', uv: 2.63, pv: 4800, fill: '#d0ed57' },
    { name: 'unknow', uv: 6.67, pv: 4800, fill: '#ffc658' },
  ],
};
const LegendEffectOpacity = {
  componentName: 'LegendEffectOpacity',
  key: 'LegendEffectOpacity',
  title: 'Legend Effect Opacity',
  width: 600,
  height,
  colors,
  datas,
};

export {
  SimpleLineCharts,
  CustomizedDotLineChart,
  SimpleBarChart,
  MixBarChart,
  CustomShapeBarChart,
  BiaxialBarChart,
  SimpleAreaChart,
  StackedAreaChart,
  LineBarAreaComposedChart,
  CustomActiveShapePieChart,
  SpecifiedDomainRadarChart,
  SimpleRadialBarChart,
  LegendEffectOpacity,
};



// WEBPACK FOOTER //
// ./src/containers/Charts/recharts/config.js